import { loadGridItems } from '../data/loadGridItems';
import { sectorColors } from '../data/sectorColors';
import { sectorOrder } from '../data/sectorOrder';
import { predictionsGridDestroy, predictionsGridInit } from './grid-engine';

export async function mountLegacyGrid({ canvasContainer, domRoot, startSlogans, stopSlogans, dataUrl, countermeasuresUrl, assetsBaseUrl, pixelPresets }) {
  if (!dataUrl || !countermeasuresUrl) {
    throw new Error('mountLegacyGrid requires dataUrl and countermeasuresUrl');
  }
  const gridData = await loadGridItems({ dataUrl, countermeasuresUrl });
  predictionsGridInit({ canvasContainer, domRoot, startSlogans, stopSlogans, assetsBaseUrl, gridData, sectorColors, sectorOrder, pixelPresets });
}

export function unmountLegacyGrid() {
  predictionsGridDestroy();
}
